import { useEventsStore } from '~/stores/useEventsStore';

export default defineNuxtPlugin((nuxtApp) => {
  // called right after a new locale has been set
  nuxtApp.hook('i18n:localeSwitched', async ({ oldLocale, newLocale }) => {
    const eventsStore = useEventsStore();

    try {
      // settings are reloaded by the locale watcher in app.vue
      await eventsStore.fetchEventsFromApi(newLocale);
    } catch (error) {
      console.error(error);
    }
  });
});
